module.exports = __webpack_public_path__ + "static/media/upload.b4f168de.svg";